import React from 'react';
import ModuleLoader from '.';
import { useLaunchDarkly } from '../../store/LaunchDarkly';

const FSEModuleLoader = () => {
  const moduleProps = useLaunchDarkly()['config-web-app']?.ecosystem?.fseModule;

  const src = `${moduleProps?.host}${moduleProps?.pathname}`;

  return <ModuleLoader src={src} id="fleet-module-root" />;
};

export default FSEModuleLoader;
